import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#114A4E",
      d: "m10.58 13.615-2.322-2.323a.72.72 0 0 0-.522-.212.7.7 0 0 0-.532.212.72.72 0 0 0-.217.527q0 .31.217.527l2.744 2.744q.27.271.633.271.361 0 .632-.27l5.564-5.564a.73.73 0 0 0 .212-.522.7.7 0 0 0-.212-.532.72.72 0 0 0-.527-.217.72.72 0 0 0-.527.217zM5.309 20.5q-.748 0-1.278-.53a1.74 1.74 0 0 1-.53-1.278V5.308q0-.748.53-1.278t1.278-.53h4.45a2.2 2.2 0 0 1 .727-1.416Q11.117 1.499 12 1.5a2.17 2.17 0 0 1 1.525.584q.632.583.717 1.416h4.45q.749 0 1.278.53.53.53.53 1.278v13.384q0 .749-.53 1.278-.53.53-1.278.53zm0-1.5h13.384a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212V5.308a.3.3 0 0 0-.096-.212.3.3 0 0 0-.212-.096H5.308a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212v13.384q0 .116.096.212a.3.3 0 0 0 .212.096M12 4.346a.73.73 0 0 0 .75-.75.73.73 0 0 0-.75-.75.73.73 0 0 0-.75.75.73.73 0 0 0 .75.75"
    }, null, -1)
  ])))
}
export default { render: render }